// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "587ea58b1483e86da4dbf462fd316399" + ".js";
};